import { useState } from "react";

import { Header } from "./Header";
import { Table } from "./Table";
import styles from "./disputes.module.scss";


export const Disputes = () => {
  const [isTableLoading, setIsTableLoading] = useState(true);
  const [dateRange, setDateRange] = useState({
    created_at_from: "",
    created_at_to: ""
  });

  return (
    <div className={styles["disputes-wrapper"]}>
      <Header
        isTableLoading={isTableLoading}
        setDateRange={setDateRange}
      />

      <Table
        dateRange={dateRange}
        isTableLoading={isTableLoading}
        setIsTableLoading={setIsTableLoading}
      />
    </div>
  )
}
